export default "__VITE_ASSET__M4q8HXMs__"